import Vue from 'vue'
import Vuex from 'vuex'

import config from './modules/config.js'
import user from './modules/user.js'
import userPreferences from './modules/userPreferences.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  plugins: [ ],
  modules: {
    config,
    user,
    userPreferences,
  },
  strict: debug
})